/**
 * Partner results component.
 *
 * Displays a list of partner search results. Renders partner cards for
 * each result and shows empty state when no partners are found or while loading.
 *
 * @module PartnerResults
 */

import PartnerCard from './PartnerCard';
import { Partner } from '@/types/partner-finder';
import { EmptyPartnersState } from './EmptyPartnersState';

interface PartnerResultsProps {
  readonly partners: Partner[];
  readonly isLoading: boolean;
  readonly onPartnerClick: (partner: Partner) => void;
  readonly onMessage: (partner: Partner) => void;
  readonly onClearFilters: () => void;
  readonly isMobile?: boolean;
}

/**
 * Component for displaying partner search results
 */
export function PartnerResults({
  partners,
  isLoading,
  onPartnerClick,
  onMessage,
  onClearFilters,
  isMobile = false,
}: PartnerResultsProps) {
  if (isLoading || partners.length === 0) {
    return (
      <EmptyPartnersState
        isLoading={isLoading}
        onClearFilters={onClearFilters}
        isMobile={isMobile}
      />
    );
  }

  return (
    <div className="space-y-4">
      {partners.map((partner) => (
        <PartnerCard
          key={partner.id}
          partner={partner}
          onClick={() => onPartnerClick(partner)}
          onMessage={() => onMessage(partner)}
        />
      ))}
    </div>
  );
}

